__turbopack_context__.v({
  "button": "styles-module-scss-module__8l-Iea__button",
  "cta": "styles-module-scss-module__8l-Iea__cta",
  "headline": "styles-module-scss-module__8l-Iea__headline",
  "sub": "styles-module-scss-module__8l-Iea__sub",
});
